import { spacing, fontSize } from '../../theme/theme';

import styled from 'styled-components';

export default styled.section`
  background: ${({ theme }) => theme.blue};
  color: white;
  padding: ${spacing.xxxl}px 0;

  > section {
    margin-bottom: ${spacing.xxl}px;
    min-width: 320px;
    max-width: 600px;
    width: 50vw;
    margin: 0 auto;
  }

  h1 {
    font-family: Fugaz One;
    text-transform: uppercase;
    margin-bottom: ${spacing.md}px;
    color: #fff;
    font-size: ${fontSize.xl};
  }
`;
